{
    "edit": "Redigere",
    "attachment": "Vedlegg",
    "backToSmartform": "Tilbake til Smartform",
    "predefined": "Forhåndsdefinert",
    "library": "Bibliotek",
    "preview": "Forhåndsvisning",
    "previewPDF": "Forhåndsvis PDF",
    "previewHTML": "Forhåndsvis HTML",
    "pdfPreview": "PDF Forhåndsvisning",
    "htmlPreview": "HTML Forhåndsvisning",
    "splitScreen": "Delt Skjerm",
    "singleScreen": "Én Skjerm",
    "refresh": "Oppdatere",
    "refreshWithLatest": "Oppdater med siste endringer",
    "refreshDisabled": "Det er ingen endringer å oppdatere",
    "loading": "Laster",
    "publish": "Publiser",
    "discard": "Forkaste",
    "previous": "Forrige",
    "next": "Neste",
    "ok": "OK",
    "cancel": "Avbryt",
    "delete": "Slett",
    "openMenu": "Åpne menyen",
    "retry": "Prøv igjen",
    "exit": "Avslutt",
    "reason": "Årsak",
    "moreoptions": "Flere valg",
    "pageBreak": "Sideskift",
    "addPageBreak": "Legg til sideskift",
    "addPageBreakBefore": "Legg til sideskift før",
    "addPageBreakAfter": "Legg til sideskift etter",
    "removePageBreak": "Fjern sideskift",
    "removePageBreakBefore": "Fjern sideskift før",
    "removePageBreakAfter": "Fjern sideskift etter",
    "blockHelpText": "Trykk Shift + F10 eller høyreklikk for alternativer",
    "paste": "Lim inn",
    "selectenoption": "Velg et alternativ",
    "none": "Ingen",
    "authentication": {
        "authenticate": "Autentisere",
        "authenticationRequired": "Autentisering Nødvendig",
        "forbidden": "Forbidden",
        "authenticateMessage": "Dette dokumentet er beskyttet og krever at brukere autentiserer seg.",
        "authFailedMessage": "Hvis dette problemet vedvarer, vennligst kontakt din systemadministrator"
    },
    "format": {
        "bold": "Fet",
        "italic": "Kursiv",
        "underline": "Understrek",
        "alignment": "Justering",
        "alignLeft": "Venstrejuster",
        "alignCenter": "Sentrér",
        "alignRight": "Høyrejuster",
        "alignJustify": "Juster marg",
        "list": "Liste",
        "bulletedList": "Punktliste",
        "numberedList": "Nummerert liste",
        "font": "Skrift",
        "size": "Størrelse",
        "fontSize": "Skriftstørrelse",
        "openFormatMenu": "Åpne formatmenyen",
        "undo": "Angre",
        "redo": "Gjenta"
    }
}